import React from 'react';

export default function ExportData() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Export PDF / Excel</h1>
      <p className="text-gray-500">Halaman Export PDF / Excel</p>
    </div>
  );
}
